import WIDGETS from './widgets';

export default {
	name: 'navbar_default',
	spacing: 2,
	sx: { width: '100%' },
	widgets: [{ content: WIDGETS.DEFAULT_NAVBAR, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 }],
};
